import { Group, HolidayVillageOutlined, Home, Money, Notifications, ThumbUp } from '@mui/icons-material';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';

const user_type = localStorage.getItem("type")

export const all_Data = [
   {
    id: 1.0,
    navLink: '/main',
    navItem: 'Dashboard',
    navIcon: (
      <span>
        <Home color="#15317E" fontSize="medium" />
      </span>
    ),
  },
  // {
  //   id: 1,
  //   navLink: '/dashboard',
  //   navItem: 'Dashboard',
  //   navIcon: (
  //     <span>
  //       <DashboardCustomizeIcon color="#15317E" fontSize="medium" />
  //     </span>
  //   ),
  // },
  {
    id: 2,
    navLink: '/district_master',
    navItem: 'Master',
    navIcon: (
      <span>
        <AddToPhotosIcon color="#15317E" fontSize="medium" />
      </span>
    ),
    subcomponent: [
      // {
      //   id: 2.1,
      //   navLink: '/master',
      //   navItem: 'Designation Master',
      //   navIcon: (
      //     <span>
      //       <AddToPhotosIcon color="#15317E" fontSize="medium" />
      //     </span>
      //   ),
      // },
      {
        id: 2.2,
        navLink: '/district_master',
        navItem: 'District Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
      {
        id: 2.3,
        navLink: '/zone_manager',
        navItem: 'Block Manager Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
      {
        id: 2.4,
        navLink: '/zone_master',
        navItem: 'Block  Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
      {
        id: 2.5,
        navLink: '/village_master',
        navItem: 'Village  Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
      {
        id: 2.6,
        navLink: '/shift_master',
        navItem: 'Shift  Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },

      {
        id: 2.7,
        navLink: '/qualification_master',
        navItem: 'Qualification  Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
      {
        id: 2.8,
        navLink: '/grade_master',
        navItem: 'Grade Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
      {
        id: 2.9,
        navLink: '/leave_master',
        navItem: 'Leave Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
      {
        id: 2.10,
        navLink: '/holiday_master',
        navItem: 'Holiday Master',
        navIcon: (
          <span>
            <AddToPhotosIcon color="#15317E" fontSize="medium" />
          </span>
        ),
      },
    ],
  },
  {
    id: 3,
    navLink: '/employee_registration',
    navItem: 'Employee Registration',
    navIcon: (
      <span>
        <Group color="#15317E" fontSize="medium" />
      </span>
    ),
  },
  {
    id: 4,
    navLink: '/employee_attendance',
    navItem: 'Employee Attendance',
    navIcon: (
      <span>
        <ThumbUp color="#15317E" fontSize="medium" />
      </span>
    ),
  },
   {
    id: 5,
    navLink: '/send_notification',
    navItem: 'Send Notification',
    navIcon: (
      <span>
        <Notifications color="#15317E" fontSize="medium" />
      </span>
    ),
  },
  {
    id: 6,
    navLink: '/emp_leave_report',
    navItem: 'Employee Leave Report',
    navIcon: (
      <span>
        <HolidayVillageOutlined color="#15317E" fontSize="medium" />
      </span>
    ),
  },
]?.map((i) => {
  return user_type === "Admin" ? i : user_type === "Zone Manager" && i?.navItem !== "Master" && i?.navItem !== "Send Notification" && i
});
